import { forwardRef } from "react";
import { QRCode } from "antd";
import { formatPosterExpiry } from "../../utils/selectionPoster";
import { useTranslation } from "../../i18n";
import "./SelectionPoster.css";

const SelectionPoster = forwardRef(function SelectionPoster(
    { albumName, expiresAtLabel, url },
    ref
) {
    const { t } = useTranslation();
    return (
        <div ref={ref} className="selection-poster">
            <div className="selection-poster__inner">
                <header className="selection-poster__header">
                    <div className="selection-poster__brand">HEI CREATIVE</div>
                    <h1 className="selection-poster__title">{albumName}</h1>
                    <div className="selection-poster__subtitle">{t("selection.share.poster.subtitle")}</div>
                </header>

                <section className="selection-poster__qr-section">
                    <div className="selection-poster__qr-wrapper">
                        <div className="selection-poster__qr-inner">
                            {url ? (
                                <QRCode
                                    value={url}
                                    size={190}
                                    color="#1d1d1f"
                                    bgColor="#ffffff"
                                    bordered={false}
                                    errorLevel="M"
                                />
                            ) : null}
                        </div>
                    </div>
                    <div className="selection-poster__qr-text">{t("selection.share.poster.scanHint")}</div>
                </section>

                <footer className="selection-poster__footer">
                    <div className="selection-poster__divider" />
                    <div className="selection-poster__expiry">
                        {t("selection.share.poster.expiryLabel")} · {formatPosterExpiry(expiresAtLabel)}
                    </div>
                    <div className="selection-poster__social">
                        <div>小红书 @伦敦摄影师小黑</div>
                        <div>Instagram @Mr.Hei_</div>
                    </div>
                    <div className="selection-poster__website">HEICREATIVE.CO.UK</div>
                </footer>
            </div>
        </div>
    );
});

export default SelectionPoster;
